import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './CompactList.module.css';
type CompactListProps<T> = {
  titlePrefix: string;
  titleSuffix?: string;
  list: T[];
  type?: string;
  className?: string;
  children: (item: T, idx: number, styles: any) => React.ReactNode;
};
const isMobile = () =>
  typeof window !== 'undefined' && window && window.innerWidth <= 768;

const CompactList = <T extends unknown>({
  titlePrefix = '',
  titleSuffix = '',
  list,
  type = '',
  className = '',
  children
}: CompactListProps<T>) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const CompactListBullet = () => (
    <div className={`${styles.linkBoxWrap__DetailsBlock} ${className}`}>
      {!isMobileDevice && (
        <h2
          className={`${styles.linkBoxWrap__Details__title} ${styles.hiddenText} desktopShow font22 latoBold appendBottom15 `}
        >
          {titlePrefix + titleSuffix}
        </h2>
      )}
      <div className={`${styles.linkBoxWrap__about}`}>
        {isMobileDevice && (
          <div className="mobileShow">
            <h2 className="paddingT16 paddingL16 appendBottom5 paddingB10">
              <span
                style={{ display: 'block' }}
                className={' blackText latoBlack font20 appendBottom2'}
              >
                {titlePrefix}
              </span>
              <span className={'font16 latoBold lineHeight20 blackText  '}>
                {titleSuffix}
              </span>
            </h2>
          </div>
        )}
        <ul className={`${styles.linkBoxWrap__List}`}>
          {list.map((item, idx) => children(item, idx, styles))}
        </ul>
      </div>
    </div>
  );
  const CompactListOrg = () => (
    <div className={`${styles.compactList__block} ${className}`}>
      {!isMobile() && (
        <h2
          className={`${styles.compactList__title} ${styles.hiddenText} desktopShow font22 latoBold appendBottom15`}
        >
          {titlePrefix}
        </h2>
      )}
      <div className={styles.compactList__body}>
        {isMobile() && (
          <h2
            className={`${styles.compactList__title} mobileShow font22 appendBottom10 latoLight`}
          >
            {titlePrefix}
          </h2>
        )}
        <ul className={styles.compactList__list}>
          {list.map((item, idx) => children(item, idx, styles))}
        </ul>
      </div>
    </div>
  );
  return type == 'bullets' ? <CompactListBullet /> : <CompactListOrg />;
};

export default CompactList;
